import { useReactiveVar } from '@apollo/client';
import { userPrivileges } from '@apollo-internal/cache';
import PrivilegeNames from '../../constants/privilegeNames';
import { useUnreadCountStore } from '../../features/notifications/notificationCenter/NotificationCenterStore';

export const useIncrementNotificationCounter = () => {
  const privileges = useReactiveVar(userPrivileges);

  const incrementUnreadCount = useUnreadCountStore.getState().incrementUnreadCount;

  const updateUnreadCount = () => {
    if (privileges.includes(PrivilegeNames.NotificationCenter)) {
      incrementUnreadCount();
    }
  };

  return updateUnreadCount;
};
